import React from 'react';
import { ReactComponent as LogoHg } from '../../media/logo_hg.svg';
import { ReactComponent as LogoHGMobile } from '../../media/logo_hg_mobile.svg';

const HGBrandLogo = ({ mobile }) => {
  const alt = 'HostGator Logo';

  return (
    mobile ? <LogoHGMobile aria-label={alt} /> : <LogoHg aria-label={alt} />
  );
};

export default HGBrandLogo;
